import React from "react";
import PaginationWithQueryState from "../../components/PaginationWithQueryState";
import OrderTable from "../components/order-table";
import { useOrdersContext } from "./orders.context";

export const OrdersList = () => {
  const { orders, totalPages, isLoadingOrders } = useOrdersContext();
  // if (!isLoadingOrders && !orders.length) {
  //   return <p className="info">No orders to show</p>;
  // }

  return (
    <>
      <div className="cell small-12 filters">
        <OrderTable items={orders} />
        {!orders.length && !isLoadingOrders && <h4>No orders to show</h4>}
      </div>
      <PaginationWithQueryState totalPages={totalPages} />
    </>
  );
};

export default OrdersList;
